import styled from 'styled-components'

const LectureUi = styled.div`
  ${({ styles = {} }) => styles}
`

export default LectureUi
